import React, { createContext, useContext, ReactNode } from 'react';
import devEnvironment from '../environments/enviornment.dev';
import prodEnvironment from '../environments/environment.prod';
import { EnvironmentVariables } from '../types/environment-variables';

const environment =
  process.env['NODE_ENV'] === 'production' ? prodEnvironment : devEnvironment;

function createEnvResource() {
  let status: 'pending' | 'success' | 'error' = 'pending';
  let result: EnvironmentVariables;
  let promise: Promise<void> | null = null;

  return {
    read() {
      if (status === 'success') return result;
      if (status === 'error') throw result;
      promise ??= fetch('/search/env.json')
        .then((res) => {
          if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
          return res.json();
        })
        .then((data: EnvironmentVariables) => {
          status = 'success';
          result = data;
        })
        .catch((err) => {
          console.error('Error fetching env.json, falling back to local:', err);
          status = 'success';
          result = environment;
        });
      throw promise;
    },
  };
}

let envResource = createEnvResource();

export const resetEnvResource = () => {
  envResource = createEnvResource();
};

export const EnvironmentContext =
  createContext<EnvironmentVariables>(environment);

export const EnvContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const envData = envResource.read();

  return (
    <EnvironmentContext.Provider value={envData}>
      {children}
    </EnvironmentContext.Provider>
  );
};

export const useEnvVariable = () => useContext(EnvironmentContext);
